export default __webpack_public_path__ + "static/media/5-suporte.639a92f7.svg";